export class Register {

  constructor(
    public email: string = '',
    public confirmEmail: string = '',
    public password: string = '',
    public confirmPassword: string = '',
    public firstName: string = '',
    public lastName: string = '',
    public token: string = '',
    public coupon: string = '',
    public planId: string = ''
  ) { }

}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/register.ts